import randomHash from "../utils/randomHash";
/**
 * 弹幕转换器
 * 将弹幕字符串转换为弹幕
 */
var DanmakuParser = /** @class */ (function () {
    function DanmakuParser() {
    }
    DanmakuParser.prototype.parse = function (d) {
        /** 转换单条弹幕 */
        try {
            var danmaku = JSON.parse(d.content);
            console.log(danmaku);
            var id = d.id || null;
            var rid = randomHash(8);
            var start = danmaku["start"] || d.time || 0;
            var duration = this.getDuration(danmaku);
            var end = start + duration;
            var danmakuData = {
                danmaku: danmaku,
                id: id,
                rid: rid,
                start: start,
                duration: duration,
                end: end,
            };
            return danmakuData;
        }
        catch (error) {
            console.log("\u5F39\u5E55\u683C\u5F0F\u9519\u8BEF-id:".concat(d.id));
        }
    };
    /** 获得一条弹幕的持续时间 */
    DanmakuParser.prototype.getDuration = function (danmaku) {
        var _a;
        var duration = danmaku.duration || 0;
        (_a = danmaku.animations) === null || _a === void 0 ? void 0 : _a.forEach(function (k) {
            duration += k.duration || 0;
        });
        return duration;
    };
    return DanmakuParser;
}());
export { DanmakuParser };
//# sourceMappingURL=DanmakuParser.js.map